import { css } from '@emotion/core';

export const EmailReset = css`
  display: inline-block;
`;

export const RadioMobileAccess = css`
  margin-top: auto;
`;
